<!-- eslint-disable max-lines -->
<template>
    <div class="contract-registration-detail-page" :v-loading="detailLoading">
        <!-- <div class="registration-head"> -->
        <div class="detail-toolBar reg-head">
            <span class="btn-head">
                <span v-show="regDetailPageState === 'main'">
                    <lots-button v-has="authorityCode.edit" type="primary" @click="editHeader" :disabled="showSaveBtn"
                        :loading="editLoading">编 辑
                    </lots-button>
                </span>
                <span v-show="showTabPage">
                    <lots-button v-has="authorityCode.save" type="primary" @click="submitMip" :disabled="showSaveBtn"
                        v-show="!showEditBtn" :loading="saveLoading">提 交
                    </lots-button>
                </span>
            </span>

            <span class="change-status" v-if="showTabPage && detailDataLocal.renewalChangeCode">
                <span class="change-title">变更单：</span><span class="change-mr">{{ detailDataLocal.renewalChangeCode
                    }}</span>
                <span v-if="![4, 7].includes(+detailDataLocal.renewalChangeFlowStatus)">
                    <span class="change-title">变更状态：</span><span class="change-mr">变更中</span>
                </span>
            </span>
        </div>
        <!-- </div> -->

        <!-- 表单区域 -->
        <collapse-infos class="infos-content" ref="upholdHealder" :detailData="detailDataLocal" :collapse="COLLAPSE"
            :activeCollapses="activeCollapses" @change="handleInfosChange">
            <!-- 表单字段插槽 -->
            <template v-slot:collapse-append="{ form, itemSetting, rIndex, collapseItem, dictData }">
                <span v-if="itemSetting.prop === 'file'">
                    <lots-upload-button :text="'上传附件'" v-if="showTabPage" :bucket="'annto-lcrm'"
                        :disabled="showSaveBtn || showEditBtn"
                        @callback="(data) => { upLoadData(form, itemSetting, data); }">
                    </lots-upload-button>
                    <div class="file-infos">
                        <template v-if="form[itemSetting.prop]
                            && form[itemSetting.prop].length">
                            <div class="file-list" v-for="(item, index) in form[itemSetting.prop]"
                                :key="index + item.fileName">
                                <div class="file-name upload" :title="item.fileName">
                                    {{ `${index + 1}. ` }}
                                    <a :href="item.fileUrl" target="_blank">{{ item.fileName }}</a>
                                </div>
                                <div class="delete-btn">
                                    <el-button type="text" plain @click="handlePreview(item)">
                                        预览
                                    </el-button>
                                    <el-button type="text" plain>
                                        <a :href="item.fileUrl" target="_blank">下载</a>
                                    </el-button>
                                    <el-button type="text" :disabled="showSaveBtn || showEditBtn" plain
                                        @click="handleDeleteFile(form, itemSetting, index)">删除</el-button>
                                </div>
                            </div>
                        </template>
                    </div>
                </span>
                <span v-else-if="itemSetting.prop === 'renewalGroupCode'">
                    <a :href="form.mipUrl" v-if="form[itemSetting.prop] && detailDataLocal.mipUrl" class="resg-mip-link"
                        target="_blank" :rel="itemSetting.label" @click.prevent="toFlowHandle(form, 'flow')">{{
                            form[itemSetting.prop] }}</a>
                    <span v-else>--</span>
                </span>
                <span v-else-if="itemSetting.prop === 'processLink'">
                    <a :href="form.processLink" v-if="form[itemSetting.prop] && form.processLink" class="resg-mip-link"
                        target="_blank" :rel="itemSetting.label" @click.prevent="toLinkHandle(form.processLink)">{{
                            form[itemSetting.prop] }}</a>
                    <span v-else>--</span>
                </span>
                <span
                    v-else-if="['causeSubcategory', 'causeCategories'].includes(itemSetting.prop) && !['', null, undefined].includes(form[itemSetting.prop])">
                    {{ itemSetting.options ? itemSetting.options[form[itemSetting.prop]] : form[itemSetting.prop] }}
                </span>
                <span v-else-if="['changeDetails'].includes(itemSetting.prop)">
                    <span class="contract-text-area"
                        v-html="(form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--'"></span>
                    <!-- <el-input
                        type="textarea"
                        :rows="5"
                        :readonly="true"
                        placeholder="--"
                        v-model="form[itemSetting.prop]">
                    </el-input> -->
                </span>
                <!-- <span v-else-if="itemSetting.prop === 'followupDate'">
                    DEBUG: 跟进日期匹配成功 - {{ getFollowupDate(form) }}
                </span> -->
                <span v-else-if="itemSetting.prop === 'followupDate'">
                    {{ followupDate }}
                </span>
                <span v-else-if="!itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                    {{ (form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--' }}
                </span>

            </template>
        </collapse-infos>
        <!-- 子页签组件 -->
        <el-collapse v-if="!showTabPage" class="contract-collapse detail-more-collapse" value="moreInfo"
            @change="handleClickMoreInfo">
            <el-collapse-item title="更多信息" name="moreInfo" ref="tabs">
                <el-tabs v-model="activeName" @tab-click="handleClickTab">
                    <el-tab-pane label="变更申请" name="applyChange">
                        <apply-change ref="applyChangeRef" :detailData="detailDataLocal" :activeName="activeName"
                            @db-apply-change="dbApplyChange">
                        </apply-change>
                    </el-tab-pane>
                    <el-tab-pane label="流程信息" name="iflowDetail">
                        <iflow-detail ref="iflowDetailRef" :detailData="detailDataLocal" :activeName="activeName">
                        </iflow-detail>
                    </el-tab-pane>
                    <el-tab-pane label="修改历史" name="history">
                        <history-list ref="filesDetailRef" :activeName="activeName" :detailData="detailDataLocal">
                        </history-list>
                    </el-tab-pane>

                </el-tabs>
            </el-collapse-item>
            <!-- <el-collapse-item name="iflow">
                <template slot="title">流程信息</template>
                <div v-if="mipUrl" class="header-operation">
                    <lots-button
                        size="mini"
                        type="primary"
                        v-if="!['7'].includes(detailDataLocal.renewalFlowStatus+'')"
                        @click="submitMip"
                        :loading="btnloading">
                        mip提交
                    </lots-button>
                    <iframe
                        class="ifr"
                        :src="mipUrl"
                        v-if="!detailLoading && mipUrl" />
                </div>
            </el-collapse-item> -->
        </el-collapse>
        <span class="position-box"></span>
        <div v-if="mipUrl" class="header-operation">
            <lots-button size="mini" type="primary" v-if="['3'].includes(detailDataLocal.renewalChangeFlowStatus + '')"
                @click="submitMip" :loading="btnloading">
                mip提交
            </lots-button>
            <iframe class="ifr" :src="mipUrl"
                v-if="!detailLoading && mipUrl && currentMipId === detailDataLocal.mipId && isCurrentPage" />
        </div>
    </div>
</template>

<script>
import { ref, reactive, computed, onMounted, watch, getCurrentInstance } from '@vue/composition-api';
import lotsButton from '@/components/lots/lotsButton';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import collapseInfos from '@/modules/mdm/views/contractModules/components/collapseInfos/CollapseInfos.vue';
import { collapse, upstreamAmplitudeRule, downstreamAmplitudeRule } from './collapseInfosConfig.js';
import { registrationGetByIdApi, contractRenewalRegistrationSingleSave, registrationChangeGetByIdApi } from '@mdm/api/contractManage/contractRegistration.js';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';
import { getNodesAndOperationApi } from '@mdm/utils/flowUtils.js';
import { Message, MessageBox } from 'element-ui';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import _ from 'lodash';
import store from '@/store/index';
import configurl from '@/config/user.env';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import iflowDetail from '../component/iflowDetail/Index';
import historyList from '../component/historyList/Index';
import applyChange from '../component/applyChange/Index';
import Decimal from 'decimal.js';
import { filePreview } from '@/utils/filePreview.js';
import utils from '@/components/utils/common.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc';
import moment from 'moment';
const { MAGIC_NUMBER } = utils;
export default {
    name: 'detailPage',
    components: { lotsButton, lotsUploadButton, collapseInfos, iflowDetail, historyList, applyChange },
    props: {
        code: {
            type: String,
            default() {
                return '';
            }
        },
        detailData: {
            type: Object,
            default() {
                return {};
            }
        },
        detailPageState: {
            type: String,
            default() {
                return 'main';
            }
        },
        activeTabs: {
            type: String,
            default() {
                return '';
            }
        }

    },
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        const config = _.cloneDeep(collapse);
        const activeCollapses = ref(['basicInfo', 'importantInfo']);
        const authorityCode = reactive(btnAuthority.contractRegistration);
        const { userName, userCode } = store.getters.user;
        const detailDataLocal = ref({});
        const readonly = ref(false);
        // const currentMonthSart = dayjs().startOf('month').valueOf(); // 获取当前时间的月份第一天时间戳
        // eslint-disable-next-line max-lines-per-function
        const COLLAPSE = computed(() => { // 配置项动态计算
            const { renewalStatus, renewalRisk, renewalContractorMip, exitStatus, causeCategories, renewalChangeCreateUserCode,
                renewalChangeFlowStatus, upstreamRenewal, upstreamAmplitude, downstreamAmplitude, downstreamRenewal, renewalFlowStatus, causeSubcategory, renewalChangeCode } = detailDataLocal.value;
            const isRisk = ['1', '2'].includes(renewalRisk + ''); // 中高风险
            const noMip = !renewalContractorMip; // 续签承接人为空
            // const causeSubcategoryFlag = ['8', '9'].includes(causeSubcategory + ''); // 终止细分原因包含：8到期涨价业务丢失 9投标竞价失败"
            const status = renewalStatus + '';
            // 提前终止时间小于本月
            // const isBefore = earlyTerminationTime && (dayjs(earlyTerminationTime).valueOf() < currentMonthSart);
            // eslint-disable-next-line max-lines-per-function
            config.forEach((v, i) => {
                // eslint-disable-next-line complexity, max-lines-per-function
                v.formList.forEach((v2, i2) => {
                    // 初始化表单内容
                    v2.disabled = collapse[i].formList[i2].disabled;
                    v2.type = collapse[i].formList[i2].type;
                    if (v2.prop === 'renewalStatus') { // 续签状态：1已洽谈(已删除) 2已续签 3已终止 4预计续签  5预计终止  6无法确认
                        v2.rule[0].required = noMip;
                    }
                    if (v2.prop === 'terminationCause') { // 终止原因
                        v2.disabled = ['2'].includes(status);
                        v2.rule[0].required = status === '3';
                    }
                    if (v2.prop === 'exitStatus') { // 终止原因大类
                        v2.disabled = ['2'].includes(status);
                        v2.rule[0].required = status === '3';
                    }
                    if (v2.prop === 'causeCategories') { // 终止原因小类
                        v2.disabled = ['2'].includes(status);
                        v2.rule[0].required = status === '3';
                        if (exitStatus) {
                            const newOptions = {};
                            // eslint-disable-next-line max-nested-callbacks
                            dictData.value['CAUSE_CATEGORIES_TO_EXIT_STATUS'] && Object.keys(dictData.value['CAUSE_CATEGORIES_TO_EXIT_STATUS']).forEach(key => {
                                if (dictData.value['CAUSE_CATEGORIES_TO_EXIT_STATUS'][key] === exitStatus) {
                                    newOptions[key] = dictData.value['CRM_CONTRACT_CAUSE_CATEGORIES'][key];
                                }
                            });
                            v2.options = newOptions;
                        } else {
                            v2.options = dictData.value['CRM_CONTRACT_CAUSE_CATEGORIES'];
                        }
                    }
                    if (v2.prop === 'causeSubcategory') { // 终止细分原因
                        v2.disabled = ['2'].includes(status);
                        v2.rule[0].required = status === '3';
                        if (causeCategories) {
                            const newOptions = {};
                            // eslint-disable-next-line max-nested-callbacks
                            dictData.value['CAUSE_SUBCATEGORY_TO_CATEGORIES'] && Object.keys(dictData.value['CAUSE_SUBCATEGORY_TO_CATEGORIES']).forEach(key => {
                                if (dictData.value['CAUSE_SUBCATEGORY_TO_CATEGORIES'][key] === causeCategories) {
                                    newOptions[key] = dictData.value['CRM_CONTRACT_CAUSE_SUBCATEGORY'][key];
                                }
                            });
                            v2.options = newOptions;
                        } else {
                            v2.options = dictData.value['CRM_CONTRACT_CAUSE_SUBCATEGORY'];
                        }
                    }
                    // if (v2.prop === 'processLink') {
                    //     v2.disabled = ['1', '2'].includes(status);
                    //     v2.rule[0].required = isBefore;
                    // }
                    if (v2.prop === 'earlyTerminationTime') {
                        v2.disabled = ['2'].includes(status);
                        v2.rule[0].required = status === '3';
                    }
                    if (v2.prop === 'renewalRisk') {
                        v2.disabled = ['2', '3'].includes(status);
                    }
                    if (v2.prop === 'riskCause') {
                        const riskCauseDisabled = ['2', '3'].includes(status);
                        const riskCauseRequired = ['2', '3'].includes(status) ? false : isRisk;
                        // if (!(Boolean(v2.disabled) === riskCauseDisabled && v2.rule[0].required === riskCauseRequired)) {
                        v2.disabled = riskCauseDisabled;
                        v2.rule[1].validator = (rule, value, callback) => {
                            if (riskCauseRequired && Array.isArray(value) && !value.length) {
                                return callback(new Error('当续签风险为高/中时,风险原因必填'));
                            }
                            return callback();
                        };
                        // }
                    }
                    if (v2.prop === 'winningSupplierName') {
                        v2.rule[0].required = causeCategories?.toString() === '10';
                    }

                    if (v2.prop === 'advanceOrDelayTime') {
                        v2.disabled = ['3'].includes(status);
                    }
                    if (v2.prop === 'upstreamRenewal') {
                        v2.rule[0].required = +renewalStatus === 2;
                    }
                    // 历史采购毛利率 历史经营中心利润率 押金金额（万元） 应收金额（万元） 续签状态为已终止时必填
                    if (['historyGrossMargin', 'historyOperateGrossMargin', 'depositAmount'].includes(v2.prop)) {
                        v2.rule[0].required = +renewalStatus === 3;
                    }
                    // 安得投标价格与安得历史价格差距 中标价格与安得投标价格差异 下游涨降幅度 下游涨降
                    //  细分原因=到期涨价业务丢失/投标竞价失败时 必填
                    if (['downstreamRenewal', 'downstreamAmplitude'].includes(v2.prop)) {
                        v2.rule[0].required = ['8', '9'].includes(causeSubcategory?.toString());
                    }
                    // 上游涨降幅度 上游涨降
                    // 续签状态为已终止时 && 细分原因=到期涨价业务丢失/投标竞价失败时 必填
                    if (['upstreamAmplitude', 'upstreamRenewal'].includes(v2.prop)) {
                        v2.rule[0].required = +renewalStatus === 3 && ['8', '9'].includes(causeSubcategory?.toString());
                    }
                    if (['upstreamAmplitude'].includes(v2.prop)) {
                        v2.rule[1].pattern = upstreamAmplitudeRule[+upstreamRenewal]?.pattern || '';
                        v2.rule[1].message = upstreamAmplitudeRule[+upstreamRenewal]?.message || '';
                        v2.rule[2].validator = (rule, value, callback) => {
                            if (['3', '6'].includes(upstreamRenewal?.toString())) {
                                if (upstreamAmplitude.toString() !== '0') {
                                    return callback(new Error('上游涨降为原价投标/原价续签时，必须为0'));
                                }
                            }
                            return callback();
                        };
                    }

                    if (['downstreamAmplitude'].includes(v2.prop)) {
                        v2.rule[1].pattern = downstreamAmplitudeRule[+downstreamRenewal]?.pattern || '';
                        v2.rule[1].message = downstreamAmplitudeRule[+downstreamRenewal]?.message || '';
                        v2.rule[2].validator = (rule, value, callback) => {
                            if (['3'].includes(downstreamRenewal?.toString())) {
                                if (downstreamAmplitude.toString() !== '0') {
                                    return callback(new Error('下游涨降为原价时，下游涨降幅度(%)必须为0'));
                                }
                            }
                            return callback();
                        };
                    }
                    if (!['winningSupplierName'].includes(v2.prop)) {
                        v2.placeholder = v2.disabled ? null : (['select', 'time'].includes(v2.type) ? '请选择' : '请输入');
                    }
                    if (['changeDetails', 'renewalChangeCause'].includes(v2.prop)) {
                        v2.visible = props.detailPageState === 'change' && !!renewalChangeCode;
                        if (v2.prop === 'renewalChangeCause') {
                            v2.disabled = !renewalChangeCode;
                            v2.rule[0].required = !!renewalChangeCode;
                        }
                    }
                    // * 3：审批中；
                    //  * 4：审批通过；
                    if ((renewalFlowStatus && [3, 4].includes(+renewalFlowStatus)) || props.detailPageState === 'main'
                        || ['3', '4', '7'].includes(String(renewalChangeFlowStatus)) || (renewalChangeCreateUserCode && renewalChangeCreateUserCode !== userCode)) {
                        v2.disabled = true;
                        v2.type = 'custom';
                    }
                });
            });
            return config;
        });

        const showTabPage = computed(() => {
            return props.detailPageState === 'change';
        });
        const showSaveBtn = computed(() => {
            // const isCreater = detailDataLocal.renewalChangeFlowCreater === userCode;
            //  3 审批中 4 审批通过
            return ['3', '4'].includes(String(detailDataLocal.value.renewalFlowStatus));
        });
        const showEditBtn = computed(() => {
            const { renewalChangeCreateUserCode } = detailDataLocal.value;
            //  3 审批中 4 审批通过
            const isCreater = (renewalChangeCreateUserCode && renewalChangeCreateUserCode !== userCode);
            return ['3', '4', '7'].includes(String(detailDataLocal.value.renewalChangeFlowStatus)) || isCreater;
        });

        const regDetailPageState = ref('');
        watch(
            () => props.detailPageState, (val) => {
                regDetailPageState.value = val;
            },
            { deep: true, immediate: true }
        );

        const dictData = ref({});
        const detailLoading = ref(false);
        onMounted(async () => {
            // eslint-disable-next-line max-len
            const res = await getDictDataApi({ dictCodes: 'CRM_CONTRACT_RENEWAL_RISK,CRM_CONTRACT_RENEWAL_RISK_CAUSE,CRM_RENEWAL_RISK_LEVEL_CAUSE,CRM_CONTRACT_RENEWAL_UPSTREAM,CRM_CONTRACT_RENEWAL_STATUS,CRM_CONTRACT_CAUSE_CATEGORIES,CRM_CONTRACT_CAUSE_SUBCATEGORY,CAUSE_CATEGORIES_TO_EXIT_STATUS,CAUSE_SUBCATEGORY_TO_CATEGORIES' });
            dictData.value = res.data;
            // fetchData();
        });
        const currentMipId = ref('');
        const fetchData = _.debounce((submitChangeCode) => {
            const { id, changeCode } = props.detailData;
            const params = {
                id
            };
            if (changeCode || submitChangeCode) {
                params.changeCode = changeCode || submitChangeCode;
            }
            detailLoading.value = true;
            const api = props.detailPageState === 'main' ? registrationGetByIdApi : registrationChangeGetByIdApi;
            api(params).then(res => {
                if (+res.code === 0 && res.data) {
                    // if (res.data.renewalFlowStatus && [3, 4].includes(+res.data.renewalFlowStatus)) {
                    //     readonly.value = true;
                    // }
                    if (!_.isNil(res.data.contractScale) && res.data.contractScale !== '') {
                        res.data.contractScale = Decimal(res.data.contractScale).toFixed(2);
                    }
                    // 判断是否展示 变更申请列表
                    if (res.data.renewalChangeCode) {
                        activeName.value = 'applyChange';
                    }
                    mipUrl.value = '';
                    // 避免和其他表单的changeDetail 冲突
                    if (res.data.hasOwnProperty('changeDetail')) {
                        res.data.changeDetails = res.data.changeDetail;
                    }
                    if (res.data.mipId) {
                        currentMipId.value = res.data.mipId;
                        handleCreate(res.data.mipId, res.data.renewalChangeFlowStatus);
                    }
                    detailDataLocal.value = {};
                    handleInfosChange({ form: formatData(res.data) });
                }
            }).finally(() => { detailLoading.value = false; });
            getCompareData();
            // eslint-disable-next-line no-magic-numbers
        }, 200);
        const compareData = ref({});
        const getCompareData = () => {
            registrationGetByIdApi({ id: props.detailData.id, change: 'change' }).then(res => {
                if (+res.code === 0) {
                    compareData.value = res.data;
                }
            });
        };
        // 处理详情展示数据格式
        const formatData = (data) => {
            const newData = _.cloneDeep(data);
            !newData.file && (newData.file = []);
            const multipleKeys = ['customerLevel', 'businessType', 'warehouseType', 'riskCause'];
            multipleKeys.forEach(key => {
                if (Array.isArray(data[key])) {
                    newData[key] = data[key];
                } else if (data[key] && data[key].length) {
                    newData[key] = data[key].split(',');
                } else if (!data[key]) {
                    newData[key] = [];
                }
            });
            return newData;
        };
        const isHandleEdit = ref(false);
        const filterClearList = computed(() => {
            // 1:已洽谈 2:已续签 3:已终止
            return {
                // 1: ['changeDetails'],
                2: ['changeDetails', 'renewalRisk', 'riskCause'],
                3: ['changeDetails', 'renewalRisk', 'riskCause'],
                4: ['changeDetails'],
                5: ['changeDetails'],
                6: ['changeDetails']
            }[detailDataLocal.value.renewalStatus] || [];
        });
        // const filterClearList = ['changeDetails'];
        // eslint-disable-next-line max-lines-per-function, complexity
        const handleInfosChange = (formObjData = {}) => { // 表单组件编辑回调，更新本地数据
            const { itemSetting, targetForm, refName } = formObjData;
            // 监控表单是否编辑过
            isHandleEdit.value = Boolean(itemSetting);
            if (!itemSetting) { // 页面初始化、刷新时走：
                detailDataLocal.value = Object.assign({}, formObjData.form);
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
            } else { // collapse组件编辑回调时走：
                if (itemSetting.prop === 'exitStatus') { // 改变终止原因大类，置空关联项
                    if (targetForm[itemSetting.prop]) {
                        targetForm['causeCategories'] = '';
                        targetForm['causeSubcategory'] = '';
                    }
                } else if (itemSetting.prop === 'causeCategories') { // 改变终止原因小类，置空关联项
                    if (targetForm[itemSetting.prop]) {
                        targetForm['causeSubcategory'] = '';
                    }
                } else if (itemSetting.prop === 'advanceOrDelayTime') {
                    targetForm['earlyTerminationTime'] = '';
                } else if (itemSetting.prop === 'upstreamRenewal') {
                    // 原价投标/原价续签 上游涨降幅度 = 0
                    targetForm['upstreamAmplitude'] = ['3', '6'].includes(targetForm[itemSetting.prop]?.toString()) ? '0' : targetForm['upstreamAmplitude'];
                } else if (itemSetting.prop === 'downstreamRenewal') {
                    // 原价  下游涨降幅度 = 0
                    targetForm['downstreamAmplitude'] = ['3'].includes(targetForm[itemSetting.prop]?.toString()) ? '0' : targetForm['downstreamAmplitude'];
                } else if (itemSetting && itemSetting.prop === 'riskCause') {
                    // 续签风险等级联动：根据风险原因确定风险等级；跨等级时取高不取低
                    const renewalRiskLevel = setRiskLevel(targetForm[itemSetting.prop]);
                    targetForm['renewalRisk'] = renewalRiskLevel;
                }
                const { file } = detailDataLocal.value;

                // 除了插槽参数以外，其他参数取最新编辑的参数更新(因：插槽的编辑不会触发collapse组件change事件回调，因此change事件回调的插槽的参数是旧数据不能取)
                detailDataLocal.value = Object.assign(
                    {},
                    detailDataLocal.value,
                    formObjData.form,
                    targetForm,
                    { file } // 保证插槽数据用最新的
                );

                if (targetForm && refName) {
                    const targetColl = COLLAPSE.value.find(item => item.ref === refName); // 根据最新状态清空禁用的字段
                    if (targetColl && targetColl.formList) {
                        targetColl.formList.forEach(col => {
                            if (col.disabled && !filterClearList.value.includes(col.prop)) {
                                targetForm[col.prop] = null;
                                ['customerLevel', 'businessType', 'warehouseType', 'riskCause'].includes(col.prop) && (targetForm[col.prop] = []);
                                col.placeholder = null;
                            }
                        });
                        detailDataLocal.value = Object.assign(
                            {},
                            detailDataLocal.value,
                            targetForm,
                            { file } // 保证插槽数据用最新的
                        );
                        //  这里保存的时候会触发,保存的校验比这里重置的快的话,保存的时候就不会有异常错误提示
                        if (itemSetting) {
                            const timer = setTimeout(() => {
                                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                                clearTimeout(timer);
                            });
                        }
                    }
                }
                const computedFiled = [{
                    label: '跟进日期',
                    prop: 'followupDate'
                }, ...config.find(item => item.ref === 'importantForm').formList ];
                detailDataLocal.value.changeDetails = getChangedFieldsAdvanced(computedFiled, compareData.value, detailDataLocal.value);
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value);
            }
        };
        const setRiskLevel = (val) => {
            const causes = Array.isArray(val) ? val.map(v => v + '') : [];
            let renewalRiskLevel = null; // 1:高 2:中 3:低
            const highRisk = dictData.value.CRM_RENEWAL_RISK_LEVEL_CAUSE['1']?.split(',') || [];
            const mediumRisk = dictData.value.CRM_RENEWAL_RISK_LEVEL_CAUSE['2']?.split(',') || [];
            const lowRisk = dictData.value.CRM_RENEWAL_RISK_LEVEL_CAUSE['3']?.split(',') || [];
            if (causes.some(it => highRisk.includes(it))) {
                renewalRiskLevel = '1';
            } else if (causes.some(it => mediumRisk.includes(it))) {
                renewalRiskLevel = '2';
            } else if (causes.some(it => lowRisk.includes(it))) {
                renewalRiskLevel = '3';
            } else {
                renewalRiskLevel = '';
            }
            return renewalRiskLevel;
        };
        const upLoadData = async (form, itemSetting, data) => {
            const { prop } = itemSetting;
            form[prop] = form[prop] ? form[prop] : [];
            if (data && +data.code === 0) {
                form[prop].push({ fileName: data.data.name, fileUrl: data.data.downUrl });
                const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
                if (prop === 'file') {
                    if (itemSetting.rule[0].required) {
                        const targetRef = formRefs.find(item => item._props.refName === 'importantForm');
                        targetRef.$refs['importantForm'].validateField(prop);
                    }
                    detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
                    isHandleEdit.value = true;
                }
            }
        };
        const handleDeleteFile = (form, itemSetting, index) => {
            const { prop } = itemSetting;
            form[prop].splice(index, 1);
            detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
            const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
            if (prop === 'file' && itemSetting.rule[0].required) {
                const targetRef = formRefs.find(item => item._props.refName === 'importantForm');
                targetRef.$refs['importantForm'].validateField(prop);
            }
            isHandleEdit.value = true;
        };
        const setNumberType = (val) => {
            if (!_.isNil(val) && val !== '') {
                val = Number(val);
            }
            return val;
        };
        const numberList = ['contractScale', 'depositAmount', 'receivableAmount', 'overdueNoInvoicedAmount', 'overdueInvoicedAmount'];
        // 处理保存字段格式
        const saveDataFormat = (data) => {
            data.customerLevel && (data.customerLevel = data.customerLevel.join(','));
            data.businessType && (data.businessType = data.businessType.join(','));
            data.warehouseType && (data.warehouseType = data.warehouseType.join(','));
            data.riskCause && (data.riskCause = data.riskCause.join(','));
            numberList.forEach(it => {
                if (data.hasOwnProperty(it)) {
                    data[it] = setNumberType(data[it]);
                }
            });
            // 添加 followupDate 的处理，使用计算属性的值
            data.followupDate = followupDate.value === '--' ? null : moment(followupDate.value).format('YYYY-MM-DD HH:mm:ss');
            data.changeDetail = data.changeDetails;
            delete data.changeDetails;
            return data;
        };
        const saveLoading = ref(false);
        const checkOtherSave = () => {
            const params = saveDataFormat(_.cloneDeep(detailDataLocal.value));

            const renewalRiskLevel = setRiskLevel(params.riskCause.split(','));
            if (renewalRiskLevel !== params.renewalRisk) {
                const riskTipsList = dictData.value.CRM_RENEWAL_RISK_LEVEL_CAUSE?.[renewalRiskLevel]?.split(',');
                const riskCauseList = _.intersection(params.riskCause.split(','), riskTipsList);
                const tipsList = riskCauseList.map(it => {
                    return dictData.value.CRM_CONTRACT_RENEWAL_RISK_CAUSE?.[it];
                })?.join('，');
                if (tipsList) {
                    Message.warning(`风险原因为${tipsList}时，续签风险需填${dictData.value.CRM_CONTRACT_RENEWAL_RISK?.[renewalRiskLevel] || ''}`);
                    // 风险原因为xxx时，续签风险需填xxxx
                    return false;
                }
            }
            const data = _.cloneDeep(setupContext.refs.upholdHealder.onsave());
            if (!data) {
                return false;
            }
            params.winningSupplierName = params.winningSupplierName?.trim();
            // if (params.causeCategories === '10' && !params.winningSupplierName) {
            //     Message.warning('终止原因小类为商机存在安得参与投标未中标，中标供应商名称（全称）必填');
            //     return false;
            // }
            // if (params.renewalChangeCode && ['', null, undefined].includes(params.renewalChangeCause)) {
            //     Message.warning('申请原因必填');
            //     return false;
            // }
            return data;
        };
        const saveHeader = async (mipSubmit = false) => {
            const data = checkOtherSave();
            if (!data) return;
            const params = saveDataFormat(_.cloneDeep(detailDataLocal.value));
            saveLoading.value = true;

            return contractRenewalRegistrationSingleSave(params).then(res => {
                if (+res.code === 0) {
                    savePendingStatus.value = false;
                    const tipsText = res.data.includes('CA') ? ',修改内容涉及关键信息，请填写修改原因后，发起流程审批，审批通过后信息才会修改' : '';
                    if (mipSubmit === true) return; // 排除点击事件的event
                    // Message.success(`保存成功${tipsText}`);
                    comfirmDialog('保存成功' + tipsText, !!tipsText);
                } else {
                    saveLoading.value = false;
                }
            }).catch(() => {
                saveLoading.value = false;
            });
        };
        // tipsText:提示文字,isMipUrl:true即滚动, true为有审批流
        const comfirmDialog = (tipsText, isMipUrl) => {
            MessageBox.confirm(tipsText, `提示：`, {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                showCancelButton: false,
                type: 'warning'
            }).then(() => {
                fetchData();
                saveLoading.value = false;
                if (!isMipUrl) return;
                const timer = setTimeout(() => {
                    scrollToHandle();
                    clearTimeout(timer);
                    // eslint-disable-next-line no-magic-numbers
                }, 1000);
            }).catch((action) => {
                fetchData();
                saveLoading.value = false;
                if (!isMipUrl) return;
                const timer2 = setTimeout(() => {
                    scrollToHandle();
                    clearTimeout(timer2);
                    // eslint-disable-next-line no-magic-numbers
                }, 1000);
            });
        };
        const editLoading = ref(false);
        const editHeader = () => {
            const params = {
                id: detailDataLocal.value.id
            };
            editLoading.value = true;
            registrationChangeGetByIdApi(params).then(res => {
                if (res && +res.code === 0) {
                    // 这里跳转变更单页面, 即新增一个续签页面
                    // detailDataLocal.value = _.cloneDeep(res.data);
                    setupContext.emit('apply-change', { ...res.data, applyChangeTime: new Date().getTime() }, 'change', '续签登记变更');
                }
            }).finally(() => {
                editLoading.value = false;
            });
        };
        const dbApplyChange = (data) => {
            setupContext.emit('apply-change', data, 'change', '续签登记变更');
        };
        const codeToName = (codes, dictObj) => {
            const names = [];
            const codesArr = codes ? codes.split(',') : [];
            if (codesArr && codesArr.length) {
                codesArr.forEach((key) => {
                    if (dictObj && dictObj[key]) {
                        names.push(dictObj[key]); // dictData.value['SYS_BMS_BUSI_TYPE']
                    }
                });
            }
            return names.join(',');
        };
        const formatValue = (value) => {
            if (_.isUndefined(value)) return null;
            if (_.isNull(value)) return null;
            if (_.isString(value) && _.isEmpty(value)) return '';
            if (_.isArray(value)) return `[${value.join(', ')}]`;
            if (_.isPlainObject(value)) return JSON.stringify(value);
            return value;
        };
        //   formName: 'importantInfo',
        const getConfigOptions = (formName, prop, val) => {
            return config.find(item => item.formName === formName).formList
                .find(item => item.prop === prop).options[val] || null;
        };
        // eslint-disable-next-line complexity
        const watchAdvanceOrDelayTime = (oldTerminationTime, newTerminationTime) => {
            /**
             * 判断续签状态和提前终止时间变更是否满足条件
             * @param {number} renewalStatus - 续签状态 (1或2)
             * @param {Date|null} oldTerminationTime - 变更前的提前终止时间
             * @param {Date|null} newTerminationTime - 变更后的提前终止时间
             * @returns {boolean} - 是否满足条件
             */
            // 如果新旧值相等（都为空或值相同），则不需要处理
            if (oldTerminationTime === newTerminationTime) {
                return false;
            }
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth(); // 0-11

            // 情况①: 有值修改为新的值
            if (oldTerminationTime && newTerminationTime) {
                return true;
            }
            // 情况②: 空值修改为有值，且修改到当前时间月份之前
            if (!oldTerminationTime && newTerminationTime) {
                // 比较日期（只比较年月）
                const newYear = new Date(newTerminationTime).getFullYear();
                const newMonth = new Date(newTerminationTime).getMonth();
                // 先比较年份，再比较月份
                return newYear < currentYear
                    || (newYear === currentYear && newMonth < currentMonth);
            }
            if (oldTerminationTime && !newTerminationTime) {
                return true;
            }
            // 其他情况都不满足条件
            return false;
        };

        // 跟进日期变更检测函数
        const watchFollowupDate = (oldFollowupDate) => {
            /**
             * 判断跟进日期变更是否满足条件
             * @param {Date|null} oldFollowupDate - 原跟进日期
             * @param {Date|null} newFollowupDate - 当前跟进日期
             * @returns {boolean} - 如果当前跟进日期月份早于原跟进日期则返回true
             */
            // 如果新旧值相等，则不需要处理
            if (oldFollowupDate === followupDate.value) {
                return false;
            }

            // 如果有任一值为空，则不进行月份比较
            if (!oldFollowupDate || !followupDate.value) {
                return false;
            }

            // 解析日期
            const oldDate = new Date(oldFollowupDate);
            const newDate = new Date(followupDate.value);

            const oldYear = oldDate.getFullYear();
            const oldMonth = oldDate.getMonth(); // 0-11
            const newYear = newDate.getFullYear();
            const newMonth = newDate.getMonth(); // 0-11

            // 如果当前跟进日期的月份早于原跟进日期，返回true
            return newYear < oldYear || (newYear === oldYear && newMonth < oldMonth);
        };

        // }
        // 自定义格式化函数
        const customFormatters = {
            'renewalStatus': val => codeToName(val, dictData.value.CRM_CONTRACT_RENEWAL_STATUS),
            'causeSubcategory': val => getConfigOptions('importantInfo', 'causeSubcategory', val),
            'upstreamRenewal': val => codeToName(val, dictData.value.CRM_CONTRACT_RENEWAL_UPSTREAM)
        };
        const changeFormList = ['renewalStatus', 'causeSubcategory', 'advanceOrDelayTime', 'earlyTerminationTime', 'upstreamRenewal', 'upstreamAmplitude', 'followupDate'];
        const changeNotNullList = ['causeSubcategory', 'upstreamRenewal', 'upstreamAmplitude']; // 空值变成有值 不触发
        const watchRenewalStatus = (oldVal, newVal) => {
            const map = { '2': ['4', '5', '6', '3'], '3': ['4', '5', '6', '2'] };
            return map[String(oldVal)]?.includes(String(newVal)) || false;
        };
        // eslint-disable-next-line max-lines-per-function
        const getChangedFieldsAdvanced = (formList, oldObj, newObj) => {
            return formList
                // eslint-disable-next-line complexity
                .map(item => {
                    const { prop, label } = item;
                    const oldValue = _.get(oldObj, prop);
                    let newValue = _.get(newObj, prop);

                    if (item.prop === 'followupDate') {
                        newValue = followupDate.value;
                    }
                    // 检查值是否实际发生变化
                    if (_.isEqual(oldValue, newValue)) return null;
                    if (!changeFormList.includes(prop)) return null;
                    // 处理特殊空值情况
                    const isTrulyEmpty = val =>
                        _.isUndefined(val)
                        || _.isNull(val)
                        || (_.isString(val) && _.isEmpty(val));

                    // 空值变有值 - 不提示
                    if (changeNotNullList.includes(prop) && isTrulyEmpty(oldValue)) {
                        return null;
                    }

                    if (item.prop === 'renewalStatus' && !watchRenewalStatus(oldValue, newValue)) {
                        return null;
                    }
                    if (item.prop === 'advanceOrDelayTime') {
                        // if (!watchAdvanceOrDelayTime(oldValue, newValue)) {
                        //     return null;
                        // }
                        // if (!oldValue) {
                        //     return null;
                        // }
                        if (!oldValue && !newValue) {
                            return null;
                        }
                        if (!watchFollowupDate(oldObj.followupDate)) {
                            return null;
                        }
                    }

                    if (item.prop === 'earlyTerminationTime') {
                        // if (!oldValue) {
                        //     return null;
                        // }
                        // if (!watchAdvanceOrDelayTime(oldValue, newValue)) {
                        //     return null;
                        // }
                        if (!oldValue && !newValue) {
                            return null;
                        }
                        if (!watchFollowupDate(oldObj.followupDate)) {
                            return null;
                        }
                    }
                    if (item.prop === 'followupDate') {
                        if (!watchAdvanceOrDelayTime(oldValue, newValue)) {
                            return null;
                        }
                        if (!oldValue) {
                            return null;
                        }
                    }

                    // 使用自定义格式化函数（如果存在）
                    const formatter = customFormatters[prop] || formatValue;
                    console.log('5555', `${label}变更：${formatter(oldValue)}修改为${formatter(newValue)}；`);
                    return `${label}变更：${formatter(oldValue)}修改为${formatter(newValue)}；`;
                })
                .filter(Boolean)
                .join('\n');
        };
        const currentTime = ref('');
        const currentAuth = ref(false);
        const mipUrl = ref('');
        // eslint-disable-next-line complexity
        const submitMip = async () => {
            // const { applicationId, mipId } = detailDataLocal.value;
            // if (applicationId) {
            //     const iflowRes = await contractWorkflowList({ contractCode: applicationId });
            //     if (+iflowRes.code === 0) {
            //         if (iflowRes.data && iflowRes.data.list && iflowRes.data.list.length && iflowRes.data.list[0].mipId
            //             && iflowRes.data.list[0].mipId === mipId) {
            //             // 通过的，不做卡控
            //         } else {
            //             Message.warning('页面审批流程信息已过期，请刷新页面再试');
            //             return false;
            //         }
            //     } else {
            //         return false;
            //     }
            // }
            try {
                const data = checkOtherSave();
                if (!data) return;
                if (!mipUrl.value) {
                    throw new Error('saveHeader');
                }
                const content = window;
                content.frames && content.frames.length && content.frames[0]
                    && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
                content.frames && content.frames.length && content.frames[1]
                    && content.frames[1].postMessage('mbpm_getApprovalData', mipUrl.value); // 解决接入了智能客服后，content.frames[0]被占用了的问题
                currentTime.value = new Date().getTime();
                store.commit('updateIflowPage', { pageTime: currentTime.value });
                scrollToHandle();
            } catch (e) {
                saveHeader(false);
            }
        };
        const handleCreate = (mipId, status) => {
            mipUrl.value = '';
            mipUrl.value = `${configurl.iflowUrl}?fdId=${mipId}&changeCode=${detailDataLocal.value.renewalChangeCode}&fdTemplateKey=CRM_renewal_change&userCode=${userCode}&userName=${userName}`;
            createMetaNode();
            window.addEventListener('message', messageFunc, false);
            if (String(status) === '3') { // 审批中
                setTimeout(() => {
                    scrollToHandle();
                    // element.scrollTo(0, MAGIC_NUMBER.TWO_THOUSAND); // 页面滚动到MIP审批位置
                }, MAGIC_NUMBER.FOUR_HUNDRED);
            }
        };
        const scrollToHandle = () => {
            const elementRules = document.querySelector(`.${props.activeTabs}`);
            if (!elementRules) return;
            elementRules.scrollTo({
                top: elementRules.getBoundingClientRect().height,
                left: 0,
                behavior: 'smooth'
            });
        };
        const createMetaNode = () => {
            const mipmeta = document.getElementById('mipmeta');
            if (mipmeta) {
                return false;
            }
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = 'upgrade-insecure-requests';
            meta.id = 'mipmeta';
            document.getElementsByTagName('head')[0].appendChild(meta);
        };
        const timer = 1800;
        // approveProcess 回调提取为独立函数，减少嵌套
        const handleApproveProcess = (params) => {
            return approveProcess(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交成功');
                    saveLoading.value = false;
                    const times = setTimeout(async () => {
                        fetchData(detailDataLocal.value.renewalChangeCode);
                        currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.mipId, loginName: userCode });
                        clearTimeout(times);
                    }, timer);
                } else {
                    Message.error(res.msg);
                }
            }).finally(() => {
                btnloading.value = false;
                saveLoading.value = false;
            });
        };
        // 参数准备辅助函数
        const prepareApproveParams = (eventData) => {
            const { id, mipId } = detailDataLocal.value;
            const { origin, pathname } = window.location;
            const params = eventData.data || {};
            const { tenantCode } = store.getters.currentTenant;
            params.tenantCode = tenantCode;
            params.currentApplicationCode = 'APP201904230047';
            if (params.formParam) {
                const { processParam } = params;
                let isToOtherPersons = '';
                if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                    isToOtherPersons = processParam.toOtherPersons;
                }
                // eslint-disable-next-line max-len
                params.formParam.fdUrl = `${origin}${pathname}#/mod/mdm/contract-registration?id=${id}&changeCode=${detailDataLocal.value.renewalChangeCode}&fdTemplateKey=CRM_renewal_change&fdId=${mipId}${isToOtherPersons ? `&isToOtherPersons=${isToOtherPersons}` : ''}`;
            }
            return params;
        };
        const savePendingStatus = ref(false);
        // draft_submit分支处理
        const handleDraftSubmit = async (params) => {
            try {
                savePendingStatus.value = true;
                await saveHeader(true);
                if (!savePendingStatus.value) {
                    await handleApproveProcess(params);
                } else {
                    btnloading.value = false;
                }
                savePendingStatus.value = false;
            } catch (e) {
                btnloading.value = false;
                savePendingStatus.value = false;
            }
        };
        // 判断当前页面的唯一iframe通信
        const isCurrentPage = computed(() => {
            const name = detailDataLocal.value.contractCode + detailDataLocal.value.companyCode + props.detailPageState;
            return props.activeTabs === name;
        });
        const btnloading = ref(false);
        // 主流程调度
        const messageFunc = async (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (!(event.data && event.data.data && event.data.success)) return;
            btnloading.value = true;
            const params = prepareApproveParams(event.data);
            const processParam = params.processParam || {};
            if (processParam.operationType === 'draft_submit') {
                await handleDraftSubmit(params);
                // handleApproveProcess(params);
                return;
            }
            handleApproveProcess(params);
        };
        const activeName = ref('iflowDetail');
        const handleClickMoreInfo = () => { // 解决点击折叠/展开“更多信息”折叠筐，子页签编辑错位问题
        };
        const handleClickTab = () => {
        };
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const toFlowHandle = (row) => {
            if (row.renewalGroupCode) {
                ctx.$router.push({ path: '/registractionFlow', query: { renewalGroupCode: row.renewalGroupCode } });
            } else {
                window.open(row.mipUrl, '_blank');
            }
        };
        const handlePreview = (row) => {
            filePreview({
                fileUrl: row.fileUrl,
                fileName: row.fileName
            });
        };
        const toLinkHandle = (url) => {
            window.open(url, '_blank');
        };

        // 跟进日期计算属性
        const followupDate = computed(() => {
            const data = detailDataLocal.value;
            // ①提前终止时间不为空，取提前终止时间
            if (data.earlyTerminationTime) {
                return data.earlyTerminationTime;
            }
            // ②提前终止时间为空，提前续签/延期时间不为空，取提前续签/延期时间
            if (data.advanceOrDelayTime) {
                return data.advanceOrDelayTime;
            }
            // ③提前终止时间为空，提前续签/延期时间为空，取失效时间
            if (data.failTime) {
                return data.failTime;
            }
            // 如果都为空，显示--
            return '--';
        });

        watch(
            () => [props.detailData, props.detailPageState],
            (newVal) => {
                if (props.detailPageState && props.detailData) {
                    fetchData();
                }
            },
            { deep: true, immediate: true }
        );
        return {
            authorityCode,
            detailLoading,
            saveLoading,
            activeCollapses,
            detailDataLocal,
            COLLAPSE,
            followupDate,
            showSaveBtn,
            showEditBtn,
            editLoading,
            regDetailPageState,
            showTabPage,
            btnloading,
            mipUrl,
            isCurrentPage,
            currentMipId,
            readonly,
            activeName,
            dictData,
            codesToNames: otherUtils.codesToNames,
            handleInfosChange,
            upLoadData,
            handleDeleteFile,
            saveHeader,
            handleClickMoreInfo,
            handleClickTab,
            toFlowHandle,
            handlePreview,
            toLinkHandle,
            editHeader,
            submitMip,
            dbApplyChange
        };
    }
};
</script>

<style lang="less">
.contract-registration-detail-page {
  .file-infos {
    width: 100%;
    padding: 0 10px 0 0;

    .file-list {
      width: 100%;
      padding: 2px 0 2px 4px;
      display: flex;

      // justify-content: space-between;
      .file-name {
        // flex: 1;
        width: 500px;
        padding-right: 5px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
      }

      .view-btn,
      .delete-btn {
        width: 200px;
        display: flex;

        a {
          text-decoration: none;
                    color: #4285F5;
        }

        .el-button {
          margin-left: 10px;
        }

        .el-button:focus,
        .el-button:hover,
        .el-button:active,
        .el-button.is-disabled {
          outline: none !important;
          border-color: transparent !important;
          /* 可选：如果要去除激活时的边框颜色变化 */
        }
      }
    }
  }

  .collapse-infos {
    .el-collapse {
      .el-collapse-item:first-child {
        .el-form-item {
          margin-bottom: 2px;
        }
      }

      .el-collapse-item__arrow {
        margin: 0 8px 0 5px;
      }
    }
  }

  .reg-head {
    position: sticky;
    z-index: 999;
    background-color: #fff;
    top: 0;
  }

  .detail-toolBar {
    display: flex;
    align-content: center;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 26px;

    .btn-head {
      width: 45px;
      height: 40px;
      line-height: 40px;

    }
  }

  .header-operation {
    margin-top: 16px;
  }

  .ifr {
    width: 100%;
    height: 100vh;
    border: none;
  }

  .contract-text-area {
        white-space: pre-wrap
  }
}

.resg-mip-link {
  text-decoration: none;
  cursor: pointer;
    color: #4285F5;
  width: 100%;
  display: inline-block;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.change-status {

  // width: 100%;
  // display: flex;
  // justify-content: flex-end;
  .change-title {
    color: #888;
  }

  .change-mr {
    display: inline-block;
    margin-right: 16px;
    color: #f56c6c;
  }
}
</style>
